import { DashboardQuery } from "./Dashboard";
import { ProcessViewModel } from "./Process";

export interface ProcessQuery {
  dateType?: string;
  initialDate?: string;
  finalDate?: string;
  ncm?: string;
  departurePort?: string;
  dischargePort?: string;
  companyId?: string;
  origin?: string;
  supplier?: string;
}

export interface PurchaseOrderViewModel {
  id?: string;
  createdDate?: string;
  documentDate?: string;

  client?: string;
  cnpj?: string;
  taxRegime?: string;
  stOrDifalDestination?: string;
  totalPayed?: number;
  totalToPay?: number;

  // Invoice Information
  invoiceRef: string;
  supplier: string;
  supplierInvoiceDate: string;
  originPort: string;
  incoterm: string;
  destinationPort: string;

  // Product Information
  productNcm: string;
  containerQty: string;
  financialCost?: number | null;
  margin: string;
  nationalizationFactor?: number | null;
  finalInvoiceValue: number;
  totalFobValue: number;

  // Resource Origin
  ownCash?: boolean;
  reserveCash?: boolean;
  finimp?: boolean;
  letterOfCredit?: boolean;

  // Payment Terms - Supplier
  firstExchangeSupplierTerm?: string | null;
  firstExchangeSupplierTermDays?: number | null;
  firstExchangeSupplier: number;
  secondExchangeSupplierTerm?: string | null;
  secondExchangeSupplierTermDays?: number | null;
  secondExchangeSupplier: number;
  nationalizationSupplierTerm?: string | null;
  nationalizationSupplierTermDays?: number | null;
  nationalizationSupplier: number;

  // Payment Terms - Client
  firstExchangeClientTerm?: string | null;
  firstExchangeClientTermDays?: number | null;
  firstExchangeClient: number;
  secondExchangeClientTerm?: string | null;
  secondExchangeClientTermDays?: number | null;
  secondExchangeClient: number;
  nationalizationClientTerm?: string | null;
  nationalizationClientTermDays?: number | null;
  nationalizationClient: number;

  // Cash Flow Operation
  firstExchangeDisbursement: number;
  firstExchangeOpenTerm: number;
  firstExchangeExpectedDate: string;

  secondExchangeDisbursement: number;
  secondExchangeOpenTerm: number;
  secondExchangeExpectedDate: string;

  clearanceDisbursement: number;
  clearanceOpenTerm: number;
  clearanceExpectedDate: string;

  // Invoice Value
  invoiceValueDollar: number;
  invoiceValueReal: number;
  invoiceExpectedDate: string;

  // Operational and Financial Payments
  exchangePaymentEntry: number;
  exchangePaymentEntryDate: string;
  exchangePaymentEntryRate: number;

  exchangePaymentBalance: number;
  exchangePaymentBalanceDate: string;
  exchangePaymentBalanceRate: number;

  clearanceTotal: number;
  clearanceTotalDate: string;
  clearanceTotalRate: number;

  // Freight Information
  freightAllIn: number;
  freeTimeDays: number;
  shipmentDate: string;
  arrivalDate: string;

  // Numerary Information
  numeraryEntryDate: string;
  numeraryEntryDollar: number;
  numeraryEntryReal: number;

  numeraryBalanceDate: string;
  numeraryBalanceDollar: number;
  numeraryBalanceReal: number;

  numeraryClearanceDate: string;
  numeraryClearanceDollar: number;
  numeraryClearanceReal: number;

  numeraryComplementaryDate: string;
  numeraryComplementaryDollar: number;
  numeraryComplementaryReal: number;

  processId?: string;
  process?: ProcessViewModel;
  // Alterações de não-admin ainda sem revisão (histórico).
  pendingChanges?: number;

  // Observations
  observations: string;
  poNumber: number;
}

export interface PurchaseOrderCommand {
  corporateReason?: string;
  cnpj?: string;
  invoice?: string;
  supplier?: string;
  ncm?: string;
  product?: string;
  category?: string;
  containerQuantity?: number;
  payment?: string;
  margin?: string;
  condition?: string;
  observation?: string;
  processId?: string;
}

export interface PurchaseOrderQuery {
  columns?: string[];
  dateType?: string;
  initialDate?: string;
  paymentInitialDate?: string;
  paymentFinalDate?: string;
  graphType?: string;
  finalDate?: string;
  departurePort?: string;
  customsAgent?: string;
  dischargePort?: string;
  companyId?: string;
  countryOfOrigin?: string;
  cvfRef?: string;
  exporter?: string;
  name?: string;
  getAll?: boolean;
  getStatus?: boolean;
  type?: number;
  sortField?: string;
  sortDirection?: string;
  cnyValue?: string;
  eurValue?: string;
  jpyValue?: string;
  chfValue?: string;
  sekValue?: string;
  corporateReason?: string;
  cnpj?: string;
  invoice?: string;
  supplier?: string;
  ncm?: string;
  product?: string;
  category?: string;
  containerQuantity?: number;
  payment?: string;
  margin?: string;
  condition?: string;
  observation?: string;
  processId?: string;
  poNumber?: string;
  pageNumber?: number;
  status?: boolean;
  pageSize?: number;
  pendingOnly?: boolean;
}

export const positions = [
  { key: 0, label: "Cliente", value: "Client" },
  { key: 2, label: "Administrativo", value: "Administration" },
  { key: 3, label: "Operacional", value: "Operational" },
  { key: 4, label: "Comercial", value: "Commercial" },
  { key: 5, label: "Financeiro", value: "Financial" },
];
